import { render } from "./ServiceIcon.vue?vue&type=template&id=111aace0"
import script from "./ServiceIcon.vue?vue&type=script&lang=js"
export * from "./ServiceIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__